'use client';

import { createPlatePlugin } from 'platejs/react';

import { FixedToolbar } from 'features/Editor';
import { EmojiToolbarButton } from 'features/Editor';

export const FixedToolbarKit = [
	createPlatePlugin({
		key: 'fixed-toolbar',
		render: {
			beforeEditable: () => (
				<FixedToolbar>
					<EmojiToolbarButton />
				</FixedToolbar>
			),
		},
	}),
];
